<div style="padding-bottom: 20px">
  <div class="container">
    <router-outlet></router-outlet>

  </div>
</div>

<!-- <app-toolbar [menuItems]="filteredMenuItems"></app-toolbar> -->

